export default "__VITE_ASSET__sx9gT6am__"